import DOMPurify from 'dompurify';

// Marketplace descriptions are sender-controlled HTML persisted as-is by the backend
// (EX-6377 length-caps only), so the claim page is the last line of defence before a
// recipient's browser. Formatting tags only — no links, no media, no attributes.
const ALLOWED_TAGS = ['p', 'br', 'b', 'strong', 'i', 'em', 'u', 'ul', 'ol', 'li', 'span'];

export const sanitizeDescription = (html?: string | null): string => {
  if (!html) {
    return '';
  }

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR: [],
    // Drop the contents of anything script-like rather than unwrapping it as text.
    FORBID_CONTENTS: ['script', 'style', 'iframe', 'svg', 'noscript', 'object', 'embed', 'template'],
  });
};

// DOMPurify returns serialised HTML, so text nodes still carry entities (&amp;, &nbsp;, &lt;).
// Once the tags are gone the rest is text-only, and parsing it as inert template content decodes it.
const decodeEntities = (text: string): string => {
  const template = document.createElement('template');
  template.innerHTML = text;

  return template.content.textContent ?? '';
};

// Plain-text form, rendered as a bare text node and used for length checks (the >200-char clamp)
// and aria labels.
export const descriptionToText = (html?: string | null): string =>
  decodeEntities(sanitizeDescription(html).replace(/<[^>]*>/g, ' '))
    .replace(/\s+/g, ' ')
    .trim();
